import { Tooltip } from 'antd';
import Avatar from 'components/Avatar';
import moment from 'moment';
import styled from 'styled-components';
import { getUser } from '../../utils/auth';

const RowNotifications = (props: any) => {
  const item = props;

  const onItemClicked = (item: any) => {
    props.onToggle(false);
    props.onItemClicked(item);
  };

  const markAsRead = (item: any, visible: boolean) => {
    props.markItemAsRead(item, visible);
  };

  return (
    <ItemContainer
      key={props.id}
      onClick={async () => {
        onItemClicked(item);
      }}
    >
      <Title>{item?.title}</Title>
      <RowContainer>
        <ViewStart>
          <Avatar name={getUser()?.fullName} />
        </ViewStart>
        <ViewMiddle>
          <Tooltip
            onVisibleChange={(visible: boolean) => markAsRead(item, visible)}
            title={item.content}
          >
            <Content>{item.content}</Content>
          </Tooltip>
          {item.status === 'unread' ? (
            <TimeAgo>{moment(new Date(item.createdAt)).fromNow()}</TimeAgo>
          ) : (
            <TimeAgoGray>{moment(new Date(item.createdAt)).fromNow()}</TimeAgoGray>
          )}
        </ViewMiddle>
        <ViewEnd>
          {
            item.status === 'unread' ? (
              <UnreadIcon
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                fill="currentColor"
                viewBox="0 0 10 10"
              >
                <circle cx="5" cy="5" r="5" />
              </UnreadIcon>
            ) : null
            //   (
            //   <ReadedIcon
            //     xmlns="http://www.w3.org/2000/svg"
            //     width="10"
            //     height="10"
            //     fill="currentColor"
            //     viewBox="0 0 10 10"
            //   >
            //     <circle cx="5" cy="5" r="5" />
            //   </ReadedIcon>
            // )
          }
        </ViewEnd>
      </RowContainer>
    </ItemContainer>
  );
};

export default RowNotifications;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  height: 100px;
  border-top: 1px solid #e3e1e1;
  border-bottom: 1px var(--cl_gray300) solid;
  &:hover {
    background-color: var(--cl_gray200);
  }
`;
export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
`;
export const ViewEnd = styled.div`
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ReadedIcon = styled.svg`
  fill: var(--cl_gray400);
`;
export const UnreadIcon = styled.svg`
  fill: var(--cl_primary);
`;
export const ViewMiddle = styled.div`
  width: 80%;
  display: flex;
  padding-left: 0.5rem;
  flex-direction: column;
  justify-content: center;
`;
export const ViewStart = styled.div`
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Content = styled.div`
  font-family: Roboto;
  font-size: 14px;
  padding-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
export const TimeAgoGray = styled.div`
  font-family: Roboto;
  font-size: 12px;
  color: #c4c4c4;
`;
export const TimeAgo = styled.div`
  font-family: Roboto;
  font-size: 12px;
  color: #137ad1;
`;
export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #137ad1;
`;
